import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash', // 使用 hash 模式
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('@/components/displayAllPages.vue'),
        },
        // {
        //     title: '登录',
        //     path: '/loginPage',
        //     name: 'loginPage',
        //     component: () => import('@/components/loginPage.vue'),
        // },
        {
            title: '登录',
            path: '/loginPage',
            name: 'loginPageTwo',
            component: () => import('@/components/loginPageTwo.vue'),
        },
        {
            title: '导航栏',
            path: '/controlNavigation',
            name: '导航栏',
            component: () => import('@/components/controlNavigation.vue'),
            children: [
                {
                    title: '发布信息',
                    path: '/releaseInformation',
                    name: '发布信息',
                    component: () => import('@/components/releaseInformation.vue'),
                },
                {
                    title: '修改信息',
                    path: '/modifyInformation',
                    name: '修改信息',
                    component: () => import('@/components/modifyInformation.vue'),
                },
            ]
        },
    ]
});

export default router;
